import { checkIsPlatform, getKebabCase } from '../../utils';
export var fetchSvgFromUrl = svgUrl => {
  return fetch(svgUrl).then(response => {
    if (response.ok) {
      return response.text();
    }
    throw new Error("Fetching " + svgUrl + " failed with status " + response.status);
  });
};
var removeKeyFromString = (svgString, key) => {
  var _a;
  var index = svgString.indexOf('>');
  var regexObj = new RegExp(key + '=".*?"');
  return ((_a = svgString.substring(0, index)) === null || _a === void 0 ? void 0 : _a.replace(regexObj, "")) + '>' + svgString.substring(index + 1);
};
export var updateSVGAttributes = (svgString, color) => {
  if (svgString) {
    if (color) svgString = svgString.replace(/#000/g, color === null || color === void 0 ? void 0 : color.toString());
    if (checkIsPlatform('web')) {
      svgString = removeKeyFromString(svgString, 'width');
      svgString = removeKeyFromString(svgString, 'height');
    }
  }
  return svgString;
};
export var getIconUrlFromName = function getIconUrlFromName(iconName) {
  if (iconName === void 0) {
    iconName = 'AirtelIcon';
  }
  var icon = getKebabCase(iconName);
  var ASSETS_BASE_URL = 'https://assets.airtel.in/static-assets/design-system/icons';
  return ASSETS_BASE_URL + "/" + icon + ".svg";
};